import React, { useState } from "react";
import { ArrowLeft, Plus } from "react-bootstrap-icons";

import AddItemButton from 'components/Buttons/AddItemButton';
import ListOfNotches from 'components/ListOfNotches';

function List({
    items = [],
    onClickHandler,
    onEditHandler,
    onDeleteHandler,
    onBackClick,
    setCurrentState
}) {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    const listSettings = {};
    
    return (
        <div className="card card-paddings container-height">

            <div className="card-header card-header-paddings no-background no-border">
                <div className="p-2">
                    <h3>Favorites</h3>
                    <span>Create favorite notches to quick access</span>
                </div>
            </div>

            <div className="card-body overflow-auto p-0">

                {items.length > 0 ? (
                    <div className="flex-grow-1 overflow-auto">
                        <ListOfNotches
                            items={items}
                            settings={listSettings}
                            onClickHandler={onClickHandler}
                            onEditHandler={onEditHandler}
                            onDeleteHandler={onDeleteHandler}
                        />
                    </div>
                ) : !isMobile ? (
                    <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100">
                        <div
                            className="text-center"
                            onClick={() => setCurrentState('add')}
                            style={{ cursor: "pointer" }}
                        >
                            <Plus size={80} className="text-primary" />
                            <p className="text-muted mt-3">Click to add your first notch</p>
                        </div>
                    </div>
                ) : (
                    <></>
                )}

            </div>

            {isMobile && (
                <div className="card-footer card-footer-paddings border-top no-background">
                    <div className="d-flex justify-content-between">
                        <button
                            type="button"
                            className="btn btn-success"
                            onClick={() => setCurrentState('add')}
                        >
                            Add
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary ms-auto"
                            onClick={(e) => {
                                e.preventDefault();

                                onBackClick();
                            }}
                        >
                            <ArrowLeft className="me-2" />
                            Back
                        </button>
                    </div>
                </div>
            )}


            {!isMobile && items.length > 0 && (
                <div
                    className="card-footer card-footer-paddings no-border no-background mt-auto"
                >
                    <AddItemButton onClick={() => setCurrentState('add')} />
                </div>
            )}

        </div>
    );
};

export default List;
